import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, Optional, Self } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, NgControl } from '@angular/forms';
import { SimpleField } from '../../abstracts';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'fb-image-slider-field',
  templateUrl: './image-slider-field.component.html',
  styleUrls: ['./image-slider-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageSliderFieldComponent extends SimpleField<File[] | string[]> implements OnInit {
  @Input() showMainImage: boolean = false;
  @Input() showSlider: boolean = true;
  @Input() numberOfImages: number = 10;
  @Input() slideWidth: string = '80px';

  readonly form: FormGroup<{ images: FormArray<FormControl<File>> }> = new FormGroup({
    images: new FormArray<FormControl<File>>([]),
  });

  readonly formArray: (typeof this.form.controls)['images'] = this.form.get('images') as FormArray<FormControl<File>>;
  mainImage?: File;

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    protected override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
  }

  ngOnInit(): void {
    this.formArray.valueChanges.pipe(untilComponentDestroyed(this)).subscribe((inputValue: File[]) => {
      const control: AbstractControl = this.ngControl.control;
      if (inputValue) {
        control.setErrors(null);
        control.markAsDirty();
        control.setValue(this.formArray.value);
        return;
      }
    });
  }

  onSelectImage(target: EventTarget, index?: number): void {
    const file: File = (target as HTMLInputElement).files[0];
    if (this.formArray.controls.length < index + 1 || index === undefined) {
      this.formArray.push(new FormControl(file));
    } else {
      this.formArray.controls[index].patchValue(file);
    }
    if (!this.mainImage && this.showMainImage) {
      this.mainImage = file;
    }
  }
  onRemove(index: number): void {
    this.formArray.removeAt(index);
    if (!this.showMainImage) return;
    if (this.formArray.controls.length) {
      this.mainImage = this.formArray.controls[0].value;
    } else {
      this.mainImage = undefined;
    }
  }
}
